import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { MapPin, Star, ChevronRight, ShieldCheck } from "lucide-react";

export default function RecommendedHostels() {
  const [hostels, setHostels] = useState([]);

  useEffect(() => {
    api.get("/hostels").then((r) => {
      const list = (r.data || [])
        .filter((h) => !String(h.name || "").startsWith("TEST_"))
        .sort((a, b) => (b.rating || 0) - (a.rating || 0))
        .slice(0, 4);
      setHostels(list);
    }).catch(() => {});
  }, []);

  if (hostels.length === 0) return null;

  const priceLabel = (h) => {
    const monthly = (h.room_types || []).map((rt) => Number(rt.price_per_month)).filter((n) => n > 0);
    if (monthly.length) return { amount: Math.min(...monthly), unit: "/month" };
    return { amount: h.price_per_bed, unit: "/night" };
  };

  return (
    <div className="mt-12" data-testid="recommended-hostels-section">
      <div className="flex items-baseline justify-between gap-3">
        <h2 className="font-display font-black text-3xl tracking-tighter">Recommended for you</h2>
        <Link to="/hostels" data-testid="recommended-view-all" className="text-sm font-bold text-orange-800 hover:text-orange-900 flex items-center gap-0.5">
          View all <ChevronRight size={15} />
        </Link>
      </div>
      <div className="mt-5 flex gap-4 overflow-x-auto pb-3 snap-x snap-mandatory [-webkit-overflow-scrolling:touch]">
        {hostels.map((h) => {
          const p = priceLabel(h);
          return (
            <Link
              key={h.id}
              to={`/hostels/${h.id}`}
              data-testid={`recommended-hostel-${h.id}`}
              className="card-lift snap-start flex-shrink-0 w-[260px] bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-orange-600"
            >
              <div className="relative h-36">
                <img src={imgUrl((h.images || [])[0])} alt={h.name} className="w-full h-full object-cover" />
                <span className="absolute top-2 left-2 bg-white/90 backdrop-blur text-[10px] font-black tracking-widest uppercase px-2 py-1 rounded-full text-emerald-700">✓ Verified</span>
              </div>
              <div className="p-4">
                <div className="font-display font-bold text-base truncate">{h.name}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><MapPin size={11} /> {h.city}</div>
                <div className="mt-2 flex items-center justify-between">
                  <div className="font-display font-black text-lg text-orange-800">₹{Number(p.amount).toLocaleString("en-IN")}<span className="text-[11px] font-body font-normal text-slate-500">{p.unit}</span></div>
                  <div className="flex items-center gap-1 text-xs font-semibold"><Star size={12} className="fill-amber-600 text-amber-600" /> {h.rating}</div>
                </div>
                <div className="mt-1.5 text-[10px] font-bold text-emerald-700 flex items-center gap-1"><ShieldCheck size={10} /> No hidden charges</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
